import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { GoogleDriveAuthComponent } from './google-drive-auth';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('google-drive-auth', {
            url: '/google-drive-auth',
            params: {
                code: ''
            },
            ncyBreadcrumb: {
                label: 'Google Drive Authorization',
                // abstract: true
            },
            data: {
                pageTitle: 'Google Drive Authorization'
            },
            views: {
                'multiContent': {
                    template: '<google-drive-auth flex="100"></google-drive-auth>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const GoogleDriveAuthModule: string = ng
    .module('archiSmall.components.googleDriveAuthModule', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('googleDriveAuth', GoogleDriveAuthComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/google-drive-auth/google-drive-auth.module.ts